import "./progress.css";
import { CurrentWeekLogsInterface } from "../../interface/currentWeekLogsInterface";
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import { NationalHolidaysInterface } from "../../interface/nationalHolidayInterface";

interface ProgressParams {
    weekdayName: string;
    weekDayDate: string;
    currentWeekLogs: CurrentWeekLogsInterface[];
    holidays: string[];
    isWeekend: boolean;
    nationalHolidays: NationalHolidaysInterface[]
}

function formatNumber(value: number) {
    if (value % 1 !== 0) {
        return value.toFixed(1);
    } else {
        return value.toFixed(0);
    }
}

const VerticalProgressBar = ({
    weekdayName,
    weekDayDate,
    currentWeekLogs,
    holidays,
    isWeekend,
    nationalHolidays
}: ProgressParams) => {
    holidays = Object.values(holidays);
    const nationalHolidaysDates = nationalHolidays?.map(holiday => holiday.date);
    const filteredData = currentWeekLogs.filter(
        (obj) => obj.date === weekDayDate
    );
    const totalDurationInMs = filteredData.reduce(
        (acc: number, curr: CurrentWeekLogsInterface) => {
            const duration = curr.duration;
            return acc + duration;
        },
        0
    );
    const hours = parseFloat(formatNumber(totalDurationInMs / 60));
    const progressColor =
        hours < 8 ? "insufficient" : hours == 8 ? "sufficient" : "overtime";

    let progressHeight = `${Math.min(hours, 8) * 12.5}%`;

    if (isWeekend && hours == 0) return (<></>);

    if ((nationalHolidaysDates?.includes(weekDayDate)) && hours == 0) {
        return (
            <>
                <small className="text"><img 
                    style={{ width: "25px", height: "auto" }}
                    src="/flag-for-flag-north-macedonia.svg"></img></small>
                <div className="progress-bar" data-progress="off">
                    <div className="progress"></div>
                </div>
                <small className="text">{weekdayName?.substring(0, 3)}</small>
            </>
        );
    }
    else if ((holidays?.includes(weekDayDate)) && hours == 0) {
        return (
            <>
                <small className="text"><BeachAccessIcon></BeachAccessIcon></small>
                <div className="progress-bar" data-progress="off">
                    <div className="progress"></div>
                </div>
                <small className="text">{weekdayName?.substring(0, 3)}</small>
            </>
        );
    }

    return (
        <>
            <small className="text">{hours}h</small>
            <div
                className="progress-bar"
                data-progress-state={hours > 8 ? "error" : "normal"}
                data-progress={hours}
                data-progress-color={progressColor}
            >
                <div
                    className="progress"
                    style={{ height: progressHeight }}
                ></div>
            </div>
            <small className="text">{weekdayName?.substring(0, 3)}</small>
        </>
    );
};

export default VerticalProgressBar;
